export default "__VITE_ASSET__48ed7c5b__"